import { Component } from '@angular/core';
import { ABBICONS } from '@constants/icons';
import { abbIconsMapper } from '@components/abb-icon/icons';
import { AbbCommonModule } from 'app/abb-common.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

// TODO: temporaneo
@Component({
  selector: 'abb-test',
  standalone: true,
  imports: [
    AbbCommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  template: `
    <p class="flex flex-col gap-4 p-8">
      <!-- <span class="flex flex-col gap-4 max-w-32" [formGroup]="form">
        <mat-form-field class="w-full" color="warn">
          <abb-input-field label="name" [floatLabel]="true">
            <input matInput formControlName="name" name="name">
          </abb-input-field>
        </mat-form-field>
        <mat-form-field class="w-full" color="warn">
          <abb-input-field label="name" [floatLabel]="false">
            <input matInput formControlName="name" name="name">
          </abb-input-field>
        </mat-form-field>
      </span> -->
      <span class="flex flex-row gap-4">
        <abb-switch label="test" name="test" />
      </span>
      <span class="flex flex-row gap-4">
        <abb-button>label</abb-button>
        <abb-button
          ><abb-icon [name]="'abb/add-user'" [size]="'small'"
        /></abb-button>
        <abb-button variant="primary">label</abb-button>
        <abb-button variant="primary"
          ><abb-icon [name]="'abb/add-user'" [size]="'small'"
        /></abb-button>
        <abb-button variant="secondary">Stop Editing</abb-button>
        <abb-button variant="secondary"
          ><abb-icon [name]="'abb/add-user'" [size]="'small'"
        /></abb-button>
        <abb-button variant="primary-rect">label</abb-button>
        <abb-button variant="primary-rect"
          ><abb-icon [name]="'abb/add-user'" [size]="'small'"
        /></abb-button>
        <abb-button variant="clean">label</abb-button>
        <abb-button variant="clean"
          ><abb-icon [name]="'abb/add-user'" [size]="'small'"
        /></abb-button>
      </span>
      <span class="flex flex-row gap-4">
        <abb-button [disabled]="true">label</abb-button>
        <abb-button [disabled]="true"
          ><abb-icon [name]="'abb/add-user'" [size]="'small'"
        /></abb-button>
        <abb-button [disabled]="true" variant="primary">label</abb-button>
        <abb-button [disabled]="true" variant="primary"
          ><abb-icon [name]="'abb/add-user'" [size]="'small'"
        /></abb-button>
        <abb-button [disabled]="true" variant="secondary">label</abb-button>
        <abb-button [disabled]="true" variant="secondary"
          ><abb-icon [name]="'abb/add-user'" [size]="'small'"
        /></abb-button>
        <abb-button [disabled]="true" variant="primary-rect">label</abb-button>
        <abb-button [disabled]="true" variant="primary-rect"
          ><abb-icon [name]="'abb/add-user'" [size]="'small'"
        /></abb-button>
        <abb-button [disabled]="true" variant="clean">label</abb-button>
        <abb-button [disabled]="true" variant="clean"
          ><abb-icon [name]="'abb/add-user'" [size]="'small'"
        /></abb-button>
      </span>
      <span class="flex flex-row gap-4">
        <abb-button variant="circular" [size]="'36'">label</abb-button>
        <abb-button variant="circular" [size]="'36'"
          ><abb-icon [name]="'abb/add-user'"
        /></abb-button>
        <abb-button variant="circular" [size]="'40'">label</abb-button>
        <abb-button variant="circular" [size]="'40'"
          ><abb-icon [name]="'abb/add-user'"
        /></abb-button>
        <abb-button variant="circular" [size]="'60'">label</abb-button>
        <abb-button variant="circular" [size]="'60'"
          ><abb-icon [name]="'abb/add-user'"
        /></abb-button>
      </span>
      <span class="flex flex-row gap-4">
        <abb-button variant="circular" [disabled]="true" [size]="'36'"
          >label</abb-button
        >
        <abb-button variant="circular" [disabled]="true" [size]="'36'"
          ><abb-icon [name]="'abb/add-user'"
        /></abb-button>
        <abb-button variant="circular" [disabled]="true" [size]="'40'"
          >label</abb-button
        >
        <abb-button variant="circular" [disabled]="true" [size]="'40'"
          ><abb-icon [name]="'abb/add-user'"
        /></abb-button>
        <abb-button variant="circular" [disabled]="true" [size]="'60'"
          >label</abb-button
        >
        <abb-button variant="circular" [disabled]="true" [size]="'60'"
          ><abb-icon [name]="'abb/add-user'"
        /></abb-button>
      </span>
      <span class="flex flex-row gap-4">
        <abb-button variant="circular" [color]="'abb-gray-02'" [size]="'36'"
          >label</abb-button
        >
        <abb-button variant="circular" [color]="'abb-gray-02'" [size]="'36'"
          ><abb-icon [name]="'abb/add-user'"
        /></abb-button>
        <abb-button variant="circular" [color]="'abb-gray-02'" [size]="'40'"
          >label</abb-button
        >
        <abb-button variant="circular" [color]="'abb-gray-02'" [size]="'40'"
          ><abb-icon [name]="'abb/add-user'"
        /></abb-button>
        <abb-button variant="circular" [color]="'abb-gray-02'" [size]="'60'"
          >label</abb-button
        >
        <abb-button variant="circular" [color]="'abb-gray-02'" [size]="'60'"
          ><abb-icon [name]="'abb/add-user'"
        /></abb-button>
      </span>
      <span class="flex flex-row gap-4">
        <abb-button
          variant="circular"
          [disabled]="true"
          [color]="'abb-gray-02'"
          [size]="'36'"
          >label</abb-button
        >
        <abb-button
          variant="circular"
          [disabled]="true"
          [color]="'abb-gray-02'"
          [size]="'36'"
          ><abb-icon [name]="'abb/add-user'"
        /></abb-button>
        <abb-button
          variant="circular"
          [disabled]="true"
          [color]="'abb-gray-02'"
          [size]="'40'"
          >label</abb-button
        >
        <abb-button
          variant="circular"
          [disabled]="true"
          [color]="'abb-gray-02'"
          [size]="'40'"
          ><abb-icon [name]="'abb/add-user'"
        /></abb-button>
        <abb-button
          variant="circular"
          [disabled]="true"
          [color]="'abb-gray-02'"
          [size]="'60'"
          >label</abb-button
        >
        <abb-button
          variant="circular"
          [disabled]="true"
          [color]="'abb-gray-02'"
          [size]="'60'"
          ><abb-icon [name]="'abb/add-user'"
        /></abb-button>
      </span>
    </p>
    <br />
    <p class="p-8">
      @for(icon of ABBICONS; track icon){
      <abb-icon
        [name]="icon"
        [size]="'large'"
        class="text-abb-primary inline-flex"
      />
      }
    </p>
    <p class="p-8">
      <abb-icon
        [name]="'abb/add-user'"
        [size]="'small'"
        class="text-blue-600"
      />
      <abb-icon
        [name]="'abb/add-user'"
        [size]="'medium'"
        class="text-abb-primary"
      />
      <abb-icon [name]="'abb/add-user'" [size]="'large'" />

      <abb-icon
        [name]="'mat/notifications'"
        [size]="'small'"
        class="text-blue-600"
      />
      <abb-icon
        [name]="'mat/notifications'"
        [size]="'medium'"
        class="text-abb-primary"
      />
      <abb-icon [name]="'mat/notifications'" [size]="'large'" />

      <abb-icon
        [name]="'mat-outlined/dashboard'"
        [size]="'small'"
        class="text-blue-600"
      />
      <abb-icon
        [name]="'mat-outlined/dashboard'"
        [size]="'medium'"
        class="text-abb-primary"
      />
      <abb-icon [name]="'mat-outlined/dashboard'" [size]="'large'" />
      <abb-button (onclick)="changeTheme()">change theme</abb-button>
    </p>
  `,
  styles: ``,
  host: {
    class: 'w-full h-full',
  },
})
export class TestComponent {
  readonly ABBICONS = Object.values(ABBICONS).map(
    (icon) => `abb/${icon}`
  ) as Array<`abb/${keyof (typeof abbIconsMapper)['small']}`>;
  readonly form = new FormGroup({
    name: new FormControl(null, [Validators.required]),
  });

  changeTheme() {
    if (document.body.dataset['theme'] !== 'example') {
      document.body.dataset['theme'] = 'example';
    } else {
      document.body.dataset['theme'] = 'default';
    }
  }
}
